{
	"errorBrowserStorageMessage": "Please make sure you have enough browser storage space and local disk space. Please contact {{email}} for assistance if needed.",
	"errorBrowserStorageTitle": "Not enough storage to access and update your project",
	"errorCatalogInvalidMessage": "{{productName}} could not open this project's catalog. Please verify you selected the correct project folder and the catalog file is not corrupted.",
	"errorCatalogInvalidTitle": "Project catalog is invalid or corrupted",
	"errorCloseProject": "Close Project",
	"errorGeneric": "An error occurred while accessing the project. Please reload the app and try again.",
	"errorHaveEnoughSpace": "I have enough space",
	"errorMaybeStorageMessage": "Please free up some disk space and try again.",
	"errorMaybeStorageTitle": "You may not have enough storage to access and update your project",
	"errorPermissionMessage": "Please retry by reloading the app or reopening the project. Please make sure the folder is not locked and you have Read & Write permissions.",
	"errorPermissionTitle": "Permission error when trying to access project",
	"errorProjectConflict": "This project is already in use by another account!",
	"errorProjectNotFound": "The project you are trying to access does not exist. Please check the folder location.",
	"errorReload": "Reload",
	"errorReportSent": "Thanks for confirming. We've received your report.",
	"errorStorageMessage": "Please free up some disk space and try again.",
	"errorStorageTitle": "Not enough storage to access and update your project",
	"errorWebGL": "WebGL is not available on this device. Please try a different browser or enable hardware acceleration."
}
